import { Mark, mergeAttributes } from '@tiptap/core';
const Underline = Mark.create({
  name: 'underline',
  addAttributes() {
    return {
      underline: {
        default: null,
        parseHTML: element => element.style.textDecoration,
        renderHTML: attributes => {
          if (!attributes.underline) {
            return {};
          }
          return {
            style: `text-decoration: underline ${attributes.underline}`
          };
        }
      }
    };
  },
  parseHTML() {
    return [{
      style: 'text-decoration',
      consuming: false,
      getAttrs: style => style.includes('underline') ? {} : false
    }];
  },
  renderHTML({
    HTMLAttributes
  }) {
    return ['underline', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setUnderline: underline => ({
        commands
      }) => {
        return commands.setMark(this.name, {
          underline
        });
      },
      toggleUnderline: underline => ({
        commands
      }) => {
        return commands.toggleMark(this.name, {
          underline
        });
      },
      unsetUnderline: () => ({
        commands
      }) => {
        return commands.unsetMark(this.name);
      }
    };
  }
});
export default {
  id: 'ExpressionEditor.Extension.Underline',
  extension: Underline
};